import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100%',
        textAlign: 'center'
      }}
    >
      <Container>
        <Typography variant="h1" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
          {t('pages.notFound.title')}
        </Typography>
        <Typography variant="h5" component="h2" color="text.secondary" gutterBottom>
          {t('pages.notFound.heading')}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          {t('pages.notFound.description')}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to="/"
        >
          {t('pages.notFound.goBack')}
        </Button>
      </Container>
    </Box>
  );
};

export default NotFound; 